export default __webpack_public_path__ + "media/images/logo-3cb9c94fd3e7ff7805682cef1bfae0dd.png";